<template>
  <div>
    <div
      v-if="showOption"
      class="bg-white mb-[24px]"
    >
      <div class="flex items-center justify-between gap-[8px] mb-[24px] p-[16px] border-b-[1px] border-b-[#E5E5E5]">
        <span class="text-[#0A0A0A] font-semibold font-[16px]">
          Ajukan Pickup
        </span>
      </div>

      <div class="mx-[24px] flex items-start justify-start gap-[24px] flex-wrap pb-[24px]">
        <div class="rounded-[16px] border-[1px] border-[#E5E5E5] p-[16px] w-full max-w-[350px]">
          <div class="rounded-[10px] overflow-hidden border-[1px] border-[#E5E5E5] mb-[16px]">
            <img
              src="https://storage.googleapis.com/komerce/assets/illustration/pickup-komship.svg"
              alt="Pickup Komship"
            >
          </div>
          <span class="block text-[#0A0A0A] text-[16px] mb-[4px] font-semibold">
            Pickup Order Komship
          </span>
          <span class="block text-[#737373] text-[14px] mb-[24px]">
            Pickup untuk orderan dari Komship
          </span>
          <Button
            variant="primary"
            class="w-full"
            @click="pickupKomship = true, showOption = false"
          >
            Ajukan Pickup & Packing
          </Button>
        </div>
        <div class="rounded-[16px] border-[1px] border-[#E5E5E5] p-[16px] w-full max-w-[350px]">
          <div class="rounded-[10px] overflow-hidden border-[1px] border-[#E5E5E5] mb-[16px]">
            <img
              src="https://storage.googleapis.com/komerce/assets/illustration/packing-nonkomship.svg"
              alt="Pickup Non Komship"
            >
          </div>
          <span class="block text-[#0A0A0A] text-[16px] mb-[4px] font-semibold">
            Pickup Order Non Komship
          </span>
          <span class="block text-[#737373] text-[14px] mb-[24px]">
            Pickup untuk orderan dari Non Komship
          </span>
          <Button
            variant="primary"
            class="w-full"
            @click="packingKompack = true, showOption = false"
          >
            Ajukan Packing
          </Button>
        </div>
      </div>
    </div>
    <div v-if="pickupKomship">
      <PickupRequest
        :user-data="userData"
        :back-button="backButton"
        @back="showOption = true, pickupKomship = false"
      />
    </div>
    <div v-if="packingKompack">
      <Packing
        :user-data="userData"
        :back-button="backButton"
        @back="showOption = true, packingKompack = false"
      />
    </div>
  </div>
</template>

<script>
import secureLs from '@/libs/secureLs'
import { Button } from '@/@core/components/ui'
import PickupRequest from '../komship/pickup/PickupRequest'
import Packing from '../kompack/packing/Packing.vue'

export default {
  components: {
    PickupRequest,
    Packing,
    Button,
  },
  data() {
    return {
      userData: secureLs.getItem('userData'),

      pickupKomship: false,
      packingKompack: false,

      showOption: false,
      backButton: false,
    }
  },
  created() {
    if (!_.isEmpty(this.$route.params)) {
      this.showOption = false
      this.pickupKomship = true
      this.backButton = true
      return
    }
    if (this.userData.is_komship === 1 && this.userData.is_kompack === 1) {
      this.showOption = true
      this.backButton = true
    } else if (this.userData.is_komship === 1 && this.userData.is_kompack === 0) {
      this.pickupKomship = true
    } else if (this.userData.is_komship === 0 && this.userData.is_kompack === 1) {
      this.packingKompack = true
    }
  },
}
</script>

<style scoped>
img { position: relative; z-index: 100; }
</style>
